import { Button } from "antd";
import React from "react";
import "./style.scss";

export default function ButtonComponent({
  text,
  type,
  href,
  className,
  theme,
  handleOnclick,
}) {
  let buttonProps = { onClick: handleOnclick };
  const typeConditionalProps =
    type === "link"
      ? {
          type: "link",
          href,
          className: `commonButton ${theme === "dark" ? "darkCommonBtn" : ""} ${
            className ? className : ""
          }`,
        }
      : {
          className: `commonButton ${theme === "dark" ? "darkCommonBtn" : ""} ${
            className ? className : ""
          }`,
        };
  buttonProps = { ...buttonProps, ...typeConditionalProps };

  return (
    <>
      <Button {...buttonProps}>{text}</Button>
    </>
  );
}
